import * as actionTypes from './actionTypes'
import { wbChangeLangProject } from './wbChangeLangProject'
import { List } from 'immutable'
import { doProcessRules, getSystemVariable } from '../../lib/processPortalRules'
import { getPreviewDynamicData } from '../../lib/projectAxios'

const filterParamFn = (param) =>
  param.get('valueType') === 'system' && ['geoLat', 'geoLong', 'geoAccuracy'].includes(param.get('systemValue'))
const filterParamIpFn = (param) =>
  param.get('valueType') === 'system' && ['ip', 'locationByIp'].includes(param.get('systemValue'))

export const projectPreviewDetectLocationAPI = () => (dispatch, getState) => {
  let state = getState()
  let projectParams = state.getIn(['project', 'params'], List()).filter(filterParamFn)
  let pageParams = state.getIn(['pages', state.get('page'), 'Props', 'params'], List()).filter(filterParamFn)

  const pageUID = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === state.get('page'))
    ?.get?.('uid')

  if (projectParams.size > 0 || pageParams.size > 0) {
    if (
      typeof navigator !== 'undefined' &&
      'geolocation' in navigator &&
      typeof navigator.geolocation.getCurrentPosition === 'function'
    ) {
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }

      function success(pos) {
        var crd = pos.coords

        // console.log('Your current position is:');
        // console.log(`Latitude : ${crd.latitude}`);
        // console.log(`Longitude: ${crd.longitude}`);
        // console.log(`More or less ${crd.accuracy} meters.`);
        let state = getState()
          .setIn(['params', 'geoLat'], crd.latitude)
          .setIn(['params', 'geoLong'], crd.longitude)
          .setIn(['params', 'geoAccuracy'], crd.accuracy)

        const changes = []

        projectParams.map((param) => {
          state = state.setIn(['params', param.get('id')], getSystemVariable(param.get('systemValue'), state))
          changes.push([param.get('id')])
        })

        pageParams.map((param) => {
          state = state.setIn(['state', pageUID, param.get('id')], getSystemVariable(param.get('systemValue'), state))
          changes.push([pageUID, param.get('id')])
        })

        dispatch({
          type: actionTypes.SET_STORE,
          payload: {
            store: doProcessRules(state, false, false, [], changes),
          },
        })
      }

      function error(err) {
        console.warn(`ERROR(${err.code}): ${err.message}`)
      }

      navigator.geolocation.getCurrentPosition(success, error, options)
    }
  }
  let projectIPParams = state.getIn(['project', 'params'], List()).filter(filterParamIpFn)
  let pageIPParams = state.getIn(['pages', state.get('page'), 'Props', 'params'], List()).filter(filterParamIpFn)
  if (projectIPParams.size > 0 || pageIPParams.size > 0) {
    let prevData = getPreviewDynamicData()
    let ip = prevData?.freshState?.ip ?? ''
    let locationByIp = prevData?.freshState?.locationByIp ?? ''
    let state = getState().setIn(['params', 'ip'], ip).setIn(['params', 'locationByIp'], locationByIp)

    const changes = []
    projectIPParams.map((param) => {
      state = state.setIn(['params', param.get('id')], getSystemVariable(param.get('systemValue'), state))
      changes.push([param.get('id')])
    })

    pageIPParams.map((param) => {
      state = state.setIn(['state', pageUID, param.get('id')], getSystemVariable(param.get('systemValue'), state))
      changes.push([pageUID, param.get('id')])
    })

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: doProcessRules(state, false, false, [], changes),
      },
    })
  }
}

export const projectPreviewSetOnLoadData = (isSetPageParams) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.PROJECT_PREVIEW_SET_ON_LOAD_DATA,
  })
  if (isSetPageParams) {
    dispatch({
      type: actionTypes.PROJECT_SET_RESET_PAGE_PARAMS,
      payload: {},
    })
  }
  let state = getState()
  let ftLang = state.get('FTLang')
  dispatch(wbChangeLangProject(ftLang))
}
